import request from '@/utils/request'
// 项目详情 列表
export function getProject(data) {
  return request({
    url: '/api/Project/getProject',
    method: 'POST',
    data: data || {}
  })
}
// 课前任务讨论
export function getDiscussion(data) {
  return request({
    url: '/api/Project/getDiscussion',
    method: 'POST',
    data: data || {}
  })
}
// 难词解释
export function taskGlossary(data) {
  return request({
    url: '/api/index/taskGlossary',
    method: 'POST',
    data: data || {}
  })
}
